import React, {Component} from 'react';
import {translate} from 'react-i18next';
import Criterials from '../../process/general/criterials';
import {Table} from 'react-bootstrap';
import Title from '../generics/Title';
import swal from 'sweetalert';
import moment from 'moment';
import SvgIcon from 'react-icons-kit';
import {clipboard} from 'react-icons-kit/icomoon/clipboard';
import {search} from 'react-icons-kit/icomoon/search';
import {minusSquareO} from 'react-icons-kit/fa/minusSquareO';
import {print} from 'react-icons-kit/fa/print';
import {pencil2} from 'react-icons-kit/icomoon/pencil2';
import FloatingActionButton from 'material-ui/FloatingActionButton';
import ModalInfo from './modalInfo';
import ModalSamples from './modalSamples';
import ModalSampleResult from './modalSampleResult';
import ModalSample from './modalSample';
import {bin} from 'react-icons-kit/icomoon/bin';
import WaitingModal from '../../generics/WaitingModal';
import ModalFile from './modalFile';
import Icon from "./Components/MatrazIcon";
import ModalLabels from './Components/modalLabels';

import {download2} from 'react-icons-kit/icomoon/download2';
import {upload2} from 'react-icons-kit/icomoon/upload2';
import {undo} from 'react-icons-kit/fa/undo';
import Help from '../../generics/help';
import {ic_local_offer} from 'react-icons-kit/md/ic_local_offer';
import {notepad_add} from 'react-icons-kit/ikons/notepad_add'
import ModalCancel from './modalCancel';

var Config = require('../../../config');

class PetitionRegister extends Component{
	constructor(props){
		super(props);

		this.validateInput = this.validateInput.bind(this);
		this.viewInformation = this.viewInformation.bind(this);
		this.newSample = this.newSample.bind(this);
		//this.getList = this.getList.bind(this);
		this.printDocument = this.printDocument.bind(this);
		this.unitReserve = this.unitReserve.bind(this);
		this.handleChange = this.handleChange.bind(this);
		this.sendUnits = this.sendUnits.bind(this);
		this.editPetition = this.editPetition.bind(this);
		this.returnUnits = this.returnUnits.bind(this);
		this.getData = this.getData.bind(this);
		this.sendProducts = this.sendProducts.bind(this);
		this.devolutionProduct = this.devolutionProduct.bind(this);
		this.showColumn = this.showColumn.bind(this);
		this.deletePetition = this.deletePetition.bind(this);
		this.loadFile = this.loadFile.bind(this);
		this.viewSamples = this.viewSamples.bind(this);
		this.selectLabel = this.selectLabel.bind(this);
		this.directPrint = this.directPrint.bind(this);
		this.openDetailsApheresis = this.openDetailsApheresis.bind(this);

		this.state = {
			petitions_list: [],
			submenu: "",
			filterText:"",
			columns:[],
			pat_notif_ehcos:{},
			disable_return:true,
		}
	}

	componentDidMount(){

		this.props.socket.onerror = (event)=> {
			console.log(event);
		};

		this.props.socket.onmessage = (event) => {
			var res = JSON.parse(event.data);
			if(res.Error === "No hay impresora configurada para imprimir")
				swal('¡Error!', res.Error, 'error');
		}

		var submenu = this.props.match.path.replace('/', '');
		this.setState({submenu: submenu});

		fetch(Config.default.apiGateway.URL+'list_show?option=list_key&search=PETITION_REGISTER',{ 
	        method: 'get',
	        headers: new Headers({
	           'Authorization': 'Bearer ' + sessionStorage.getItem("token") , 
	           'Accept': 'application/json',
	            'Content-Type': 'application/json',
	        })
      	})
      	.then(response => response.json())
      	.then(response => {
        	if(response !== undefined){
          		this.setState({ columns: response });
        	}
      	})

		//this.getList();

		//Criterio funcional,cambiar lugar de colecta
		fetch(Config.default.apiGateway.URL+'functional_criterion?code=PAT_NOTIF_EHCOS&x=',{ 
			method: 'get',
			headers: new Headers({
				'Authorization': 'Bearer ' + sessionStorage.getItem("token") , 
				'Accept': 'application/json',
				'Content-Type': 'application/json',
			})
		})
		.then(response => response.json())
		.then(response => {
			this.setState({
					pat_notif_ehcos: response
				});
		})


		this.props.task_has_user_profiles.map((t)=>(
			t.type === 'CANCEL_RETURNS_DELIVERY' ?
				this.setState({disable_return:false})
			:null
		));
	}

	showColumn(column_name){
      	for(var i =0; i < this.state.columns.length;i++){
  			if(this.state.columns[i]=== column_name){
          		return false;
        	}
      	}

	    return true;
  	}

	componentDidUpdate(){
		var submenu = this.props.match.path.replace('/', '');
		if(submenu !== this.state.submenu){
			this.setState({
				submenu: submenu
			});

			this.getList();
		}
	}

	handleChange(e){
		this.setState({
			[e.target.name]: e.target.value
		});
	}

	getData(result){
		result.map((r)=>{
			r.name = r.pat_name

			r.delivered_total =  r.delivered_total !== null ? r.delivered_total : 0;
			r.reserved_total =  r.reserved_total !== null ? r.reserved_total : 0;
			r.total_required =  r.total_required !== null ? r.total_required : 0;

			if(parseInt(r.delivered_total) >= parseInt(r.reserved_total)){
				r.color = 'green';
			}else{
				r.color = 'red';
			}	


			r.units_summary = r.delivered_total+' / '+r.total_required;

			r.flag_returns = (r.total_units_return > 0 || r.total_products_return > 0) ? true : false;

			r.flag_delivered = (r.delivered_total > 0 ||  r.plasmatic_prod_total > 0) ? true : false;

			r.flag_reserved = r.reserved_total > 0 ? true: false;

			r.validations = r.total_samples_validated == 0 ? "NONE" 
							: (r.total_samples == r.total_samples_validated) ? "COMPLETE" : "INCOMPLETE";

			r.flag_samples = r.total_samples == 0 ? "NO_SAMPLES":  
								r.total_samples_expired > 0 ? "EXPIRED" : "WITH_SAMPLES"
		});

		this.setState({petitions_list:result});
	}

	validateInput(e) {
	    const re = /^[-+]?$/;

	    if (e.key === "Enter") {
      		e.preventDefault(); // Prevent form submission if button present
      		
      		const form = e.target.form;
      		const index = Array.prototype.indexOf.call(form, e.target);

      		if(form.elements[index + 1] !== undefined){
      			if(form.elements[index + 1].getAttribute("disabled") !== undefined){
    				if(form.elements[index + 1].getAttribute("disabled") === null)
    					form.elements[index + 1].focus();
    			
    				else if(form.elements[index + 1].getAttribute("disabled") === "")
    					form.elements[index + 2].focus();
    			}
      		}
    	
		    if (!re.test(e.key)) {
		      e.preventDefault();
		    }
		}
  	}

  	newPetition(){
  		this.props.history.push("/petition_register/new");
  	}

  	viewInformation(id){
  		this.props.history.push('/petition_register/view/'+id);
  		//this.modal_info.handleShow(id);
  	}

  	newSample(item){

  		var group_rh = item.lookup_group !== null && item.lookup_group !== "" ?
							item.lookup_group+
							(item.lookup_rh === 'POSITIVO' ? '+' :
								item.lookup_rh === 'NEGATIVO' ? '-' : '')
						:'';

		var name = item.pat_name
  		this.modal_samples.handleShow(
  			item.id, 
  			item.patient_id, 
  			name, 
  			group_rh,
  			'list',
  			item.health_service
  		);
  		//this.props.history.push('/petition_samples/new/'+id+'/'+petition);
  	}

  	async printDocument(e, id, t){
  		e.preventDefault();

		  var file = '';
  		switch(t){
  			case 'COMPONENTS':
  				file = 'petition_components';
  				break;
  			case 'APHERESIS':
  				file = 'petitiont_apheresis';
  				break;
  			case 'STUDY_HLA':
  				file = 'petitiont_study_hla';
  				break;
  			case 'LABORATORY':
  				file = 'petitiont_laboratory';
  				break;
  			case 'PLASMATIC_PRODUCTS':
  				file = 'petitiont_plasmatic_prod';
  				break;

  		}

		this.waiting_modal.handleShow('Imprimiendo...');
				
		var obj ={};
		obj.health_facilities_id = parseInt(sessionStorage.getItem("health_facilities_id"),10);
		obj.id = id;
		obj.file_type = file;
		obj.nEtiqueta = [0];

		var type = await this.props.getDocumentType(obj.file_type);
		
		var document;
		if(type.print_type === 'template'){
			document = await this.props.printDocumentTemplate(obj, type.print_automatically);
		}else if(type.print_type === 'external'){
			document = await this.props.printDocumentExternal(obj, type.print_automatically);
		}else if(type === undefined){
			this.props.waiting.handleClose();
		}

		if(document !== undefined){
			this.waiting_modal.handleClose();
			this.setState({ show: false});
		}else{
			this.waiting_modal.handleClose();
		}
	}
		
	directPrint(response, type){
		//PRINTER
		var reader = new FileReader();
		reader.readAsDataURL(response); 
		reader.onloadend = ()=> {
			var base64data = reader.result;  
			var aux = base64data.split(',');
			this.props.socket.send('{"Operacion":"print", "Type":"'+type+'", "File": "'+aux[1]+'"}');
		}
	}
  	
  	unitReserve(e, id){
  		this.props.history.push('/petition_register/reserve/'+id);
  		//this.modal_reserve.handleShow(id);
  	}

  	filter(row){
		var res = true;

		var string = row.id.toString()+' '+row.pet_type+' '+row.name+' '+row.clinic_history;

		if(row !== null){
			if(string.indexOf(this.state.filterText.toUpperCase()) !== -1){
				res = true;
			}else{
				res = false;
			}
		}

		return res;
	}

	sendUnits(e, id){
		//this.modal_send.handleShow(id);
		this.props.history.push('/petition_register/unitSend/'+id);
	}
	sendProducts(e, id){
		this.props.history.push('/plasmatic_products/despatch/'+id);
	}

	editPetition(e, id){
		this.props.history.push('/petition_register/edit/'+id);
	}

	returnUnits(e, id){
		//this.modal_send.handleShow(id);
		this.props.history.push('/unit_return/'+id);
	}

	sampleResults(e,item){
		e.preventDefault();
		if(item.flag_samples !== 'NO_SAMPLES'){
			this.modal_sample_result.handleShow(item.id);
		}

	}

	devolutionProduct(e, id){
		this.props.history.push('/plasmatic_products/devolution/'+id);
	}

	deletePetition(e, id){
		this.modal_cancel.handleShow(id);
		/*swal({
	        title: '¿Está seguro?',
	        text: '¿Seleccione una opción?',
	        type: 'warning',
	        showCancelButton: true,
	        confirmButtonColor: '#DD6B55',
	        confirmButtonText: 'Eliminar Petición!',
	        cancelButtonText: '¡Cancelar Petición!',
	        closeOnConfirm: true,
	        closeOnCancel: true
	    },  (isConfirm)=> {
	        if (isConfirm) {
	        	this.props.waiting.handleShow('Cargando...');
				fetch(Config.default.apiGateway.URL+'petitions/'+id, {
		  			method : 'delete',
		  			headers: new Headers({
		  				'Authorization' : 'Bearer '+sessionStorage.getItem("token"),
		  				'Accept'		: 'application/json',
		  				'Content-Type'	: 'application/json'
		  			})
		  		}).then(res => {
		  			this.props.waiting.handleClose();
		  			if(res.ok){
		  				return res.json();
		  			}else{
		  				res.text().then((msg)=>{
		  					swal("Error", msg, 'error');
		  				})
		  			}
		  		})
		  		.then(response=>{
		  			if(response !== undefined){
		  				this.criterials.getPetitionType('actives');
		  				swal('Success', 'El registro se elimino correctamente', 'success');
		  			}	
		  		})
	        }else{
	        	this.props.waiting.handleShow('Cargando...');
				fetch(Config.default.apiGateway.URL+'cancel/'+id, {
		  			method : 'delete',
		  			headers: new Headers({
		  				'Authorization' : 'Bearer '+sessionStorage.getItem("token"),
		  				'Accept'		: 'application/json',
		  				'Content-Type'	: 'application/json'
		  			})
		  		}).then(res => {
		  			this.props.waiting.handleClose();
		  			if(res.ok){
		  				return res.json();
		  			}else{
		  				res.text().then((msg)=>{
		  					swal("Error", msg, 'error');
		  				})
		  			}
		  		})
		  		.then(response=>{
		  			if(response !== undefined){
		  				this.criterials.getPetitionType('actives');
		  				swal('Success', 'El registro se cancelo correctamente', 'success');
		  			}	
		  		})
	        }
	    });*/
	}

	loadFile(e){
		e.preventDefault();
		this.modal_file.handleShow();
	}

	viewSamples(e, id){
		e.preventDefault();

		this.modal_sample.handleShow(id);
	}

	selectLabel(e, id, petition_id){
		if(e !== null){
			e.preventDefault();
		}
		
		this.modal_sample.handleClose();
		this.modal_label.handleShow(id, petition_id);
	}

	openDetailsApheresis(e, id){
		e.preventDefault();

		this.modal_details_apheresis.handleShow(id);
	}

	render(){
		const {t} = this.props;

		return (
			<div className="col-xs-12">
				<Title {...this.props} onRef={ref => (this.title = ref)} />

				<Help 
					{...this.props}
	                menu={"help_patients"} 
	                submenu={"help_petitions"}  />
	                
				<form noValidate>
					<div className="col-xs-12" style={{padding:'0'}}>
						<Criterials {...this.props} getList={this.getList} validate={this.validateInput} 
							sendData={this.getData} onRef={ref => (this.criterials = ref)} />
					</div>
					<div className="col-xs-12 form-group">
						<div className="col-xs-12 col-sm-2">
							<span className="span-min">Filtro</span>
							<input type="text" className="form-control" placeholder="Filtro..." name="filterText" 
								value={this.state.filterText} onChange={this.handleChange} />
						</div>
						{this.state.pat_notif_ehcos.value !== 'NO' ?
							<div className="col-xs-12 col-sm-2" style={{marginTop:'18px'}}>
								<button className="btn btn-info" onClick={this.loadFile}>Cargar desde archivo</button>
							</div>
						:null}
					</div>

					<div className="col-xs-12">
						<Table responsive hover>
							<thead>
								<tr>
									<th hidden={this.showColumn('PETITION_NUMBER')}>{t('content.patients.petition_register.table.no_petition')}</th>
									<th hidden={this.showColumn('CLINIC_HISTORY')}>Expediente</th>
									<th hidden={this.showColumn('DATE')}>{t('content.patients.petition_register.table.date')}</th>
									<th hidden={this.showColumn('PETITION_TYPE')}>{t('content.patients.petition_register.table.type_petition')}</th>
									<th hidden={this.showColumn('COMPONENTS')}>Comp.</th>
									{/*<th hidden={this.showColumn('CALLER_NUM')}>{t('content.patients.petition_register.table.condition')}</th>*/}
									<th hidden={this.showColumn('PATIENT')}>{t('content.patients.petition_register.table.patient')}</th>
									<th hidden={this.showColumn('SAMPLE_NUMBER')}>No. Muestra</th>
									<th hidden={this.showColumn('SAMPLE')} style={{textAlign:'center'}}>{t('content.patients.petition_register.table.sample')}</th>
									<th hidden={this.showColumn('LABORATORY')} style={{textAlign:'center'}}>Laboratorio</th>
									<th hidden={this.showColumn('GROUP_RH_SAMPLE')} style={{textAlign:'center'}} >G-RH (Muestra)</th>
									<th hidden={this.showColumn('GROUP_RH')} style={{textAlign:'center'}}>{t('content.patients.petition_register.table.group_rh')} (Paciente)</th>
									<th hidden={this.showColumn('LECTINA')} style={{textAlign:'center'}}>Lectina</th>
									<th hidden={this.showColumn('DU')} style={{textAlign:'center'}}>DU</th>
									<th hidden={this.showColumn('RESERVE')} style={{textAlign:'center'}}>Reserva</th>
									<th hidden={this.showColumn('SENT')} style={{textAlign:'center'}}>Enviado</th>
									<th hidden={this.showColumn('REFUND')} style={{textAlign:'center'}}>Devolución</th>
									<th style={{width:'40px'}}></th>
									<th hidden={this.showColumn('FLAG_APHERESIS')} style={{textAlign:'center'}}>Aféresis</th>
									<th hidden={this.showColumn('RAI')} style={{textAlign:'center'}}>RAI</th>
									<th hidden={this.showColumn('CONTROLS')} style={{width:'15em'}}></th>
								</tr>
							</thead>
							<tbody>
								{this.state.petitions_list.map((p, i)=>{
									return this.filter(p) ?
										<tr key={i}>
											<td hidden={this.showColumn('PETITION_NUMBER')}>{p.id}</td>
											<td hidden={this.showColumn('CLINIC_HISTORY')}>{p.clinic_history}</td>
											<td hidden={this.showColumn('DATE')}>
												{moment(p.petition_date).format('DD/MM/YYYY')+' '+
												moment(p.petition_hour, 'H:mm:ss').format('HH:mm')}
											</td>
											<td hidden={this.showColumn('PETITION_TYPE')}>{p.pet_type}</td>
											<td hidden={this.showColumn('COMPONENTS')}>
												{p.components !== null && p.components !== "" ?
													'('+p.components+')'
												:''}
											</td>
											{/*<td>{p.petition.observations}</td>*/}
											<td hidden={this.showColumn('PATIENT')}>{p.name}</td>
											<td hidden={this.showColumn('SAMPLE_NUMBER')}>
												{p.pet_samples}												
											</td>
											<td hidden={this.showColumn('SAMPLE')} style={{textAlign:'center'}}>
												{p.type === "COMPONENTS" ||
												p.type === 'LABORATORY' ||
											    p.type === 'STUDY_HLA' ?
											    	p.from_hemo === 0 ?
														<SvgIcon size={25} icon={clipboard} 
															style={p.status === 'CANCELADA' ?
																	{cursor:'no-drop', color:'#a39f9f'}
																: p.flag_samples === 'NO_SAMPLES' ?
																	{cursor:'pointer', color:'#a39f9f'}
																: p.flag_samples === 'WITH_SAMPLES' ?
																	{cursor:'pointer', color:'rgb(var(--primary))'}
																: {cursor:'pointer', color:'rgba(var(--primary), 0.5)'}
															}
															onClick={p.status !== 'CANCELADA' ? this.newSample.bind(this, p) : (e)=>e.preventDefault}
															/>
													: null											    	
												: null}
											</td>
											<td hidden={this.showColumn('LABORATORY')} align="center">
												{p.type === "COMPONENTS" ||
												p.type === 'LABORATORY' || 
											    p.type === 'STUDY_HLA' ?
											    	p.from_hemo ===  0 ?
														<a href="" className={p.flag_samples === 'NO_SAMPLES' ? "disabled":"" } 
															disabled={p.flag_samples === 'NO_SAMPLES' || p.status === 'CANCELADA'}
															onClick={(e)=>this.sampleResults(e,p)}>
															<Icon width={25} title="Grupo & RH"
																fill={p.validations === 'INCOMPLETE' ? 
																		'rgba(var(--primary), 0.5)' :
																	p.validations === 'COMPLETE' ?
																		'rgb(var(--primary))' :
																	'#a39f9f'}
															 />
															
														</a>
													: null
												: null}
											</td>
											<td hidden={this.showColumn('GROUP_RH_SAMPLE')} align="center" width="50">
												{p.sample_group !== null && p.sample_group !== "" ?
													p.sample_group+
													(p.sample_rh === 'POSITIVO' ? '+' :
														p.sample_rh === 'NEGATIVO' ? '-' : '')
												:''}
											</td>
											<td hidden={this.showColumn('GROUP_RH')} align="center" width="50">
												{p.lookup_group !== null && p.lookup_group !== "" ?
													p.lookup_group+
													(p.lookup_rh === 'POSITIVO' ? '+' :
														p.lookup_rh === 'NEGATIVO' ? '-' : '')
												:''}
											</td>
											<td hidden={this.showColumn('LECTINA')}>{p.lectina}</td>
											<td hidden={this.showColumn('DU')}>{p.du}</td>
											<td hidden={this.showColumn('RESERVE')} align="center">
												{p.type === "COMPONENTS" ?
													p.from_hemo === 0 ?
														<SvgIcon icon={download2} 
															style={
																p.status === 'CANCELADA' ?
																	{cursor:'no-drop', color:'#a39f9f'}
																:!p.flag_reserved ?
																	{cursor:this.props.task_unit_reserves.create ? 'pointer' : 'no-drop', color:'#a39f9f'}
																: {cursor:this.props.task_unit_reserves.create ? 'pointer' : 'no-drop', 
																	color:'rgb(var(--primary))'}
															
															}
															size={30} 
															onClick={this.props.task_unit_reserves.create ?
																p.status !== 'CANCELADA' ? 
																	(e)=>this.unitReserve(e, p.id) 
																: (e)=>e.preventDefault()
															: (e)=>e.preventDefault()
															}
														/>
													: null
												: null}
												
											</td>
											<td hidden={this.showColumn('SENT')} align="center">
												{p.from_hemo === 0 ?
													p.type  === "COMPONENTS" || p.type === 'URGENT_COMPONENTS' ?
														<SvgIcon size={25} icon={upload2} size={30} 
															title="Enviado" 
															onClick={this.props.task_unit_delivered.create ?
																p.status !== 'CANCELADA' ? (e)=>this.sendUnits(e, p.id) : (e)=>e.preventDefault()
															: (e)=>e.preventDefault()}
															style={p.status === 'CANCELADA' ?
																	{cursor:'no-drop', color:'#a39f9f'}
																:!p.flag_delivered ?
																	{cursor:this.props.task_unit_delivered.create ?'pointer' : 'no-drop', color:'#a39f9f'}
																: {cursor:this.props.task_unit_delivered.create ?'pointer' : 'no-drop',
																	color:'rgb(var(--primary))'}
															}/>
													:p.type === 'PLASMATIC_PRODUCTS'  ?
														<SvgIcon size={25} icon={upload2} size={30} 
														title="Enviado" 
														onClick={this.props.task_unit_delivered.create ?
															p.status !== 'CANCELADA' ? (e)=>this.sendProducts(e, p.id ) : (e)=>e.preventDefault()
														: (e)=>e.preventDefault()}
														style={p.status === 'CANCELADA' ?
																{cursor:'no-drop', color:'#a39f9f'}
															:!p.flag_delivered ?
																{cursor:this.props.task_unit_delivered.create ?'pointer' : 'no-drop', color:'#a39f9f'}
															: {cursor:this.props.task_unit_delivered.create ? 'pointer' : 'no-drop', 
																color:'rgb(var(--primary))'}
														}/>
													:null
												:null}
											</td>
											<td  hidden={this.showColumn('REFUND')} align="center">
												{p.type === "COMPONENTS" || p.type === 'URGENT_COMPONENTS' ?
													<SvgIcon icon={undo} 
														style={p.status === 'CANCELADA' ?
																{cursor:'no-drop', color:'#a39f9f'}
															:!p.flag_returns ?
																{cursor:this.state.disable_return ? 'no-drop' : 'pointer', color:'#a39f9f'}
															: {cursor:this.state.disable_return ? 'no-drop' : 'pointer', 
																color:'rgb(var(--primary))'}
														}
														size={30}
														onClick={!this.state.disable_return ?
															p.status !== 'CANCELADA' ? (e)=>this.returnUnits(e, p.id) : (e)=>e.preventDefault()
														:(e)=>e.preventDefault()}/>
												:p.type === 'PLASMATIC_PRODUCTS' ?
													<SvgIcon icon={undo} 
														style={p.status === 'CANCELADA' ? {cursor:'no-drop', color:'#a39f9f'} 
														: {cursor:this.state.disable_return ? 'no-drop' : "pointer"}
														} 
														size={30}
														onClick={!this.state.disable_return ?
															p.status !== 'CANCELADA' ? (e)=>this.devolutionProduct(e, p.id) : (e)=>e.preventDefault()
														: (e)=>e.preventDefault()}
														disabled={p.status === 'CANCELADA'}
													/>
												:null}
												
											</td>
											<td>
												{p.type === "COMPONENTS"  || p.type === 'PLASMATIC_PRODUCTS' ?
													<span style={{color:p.color, fontSize:12}}>{p.units_summary}</span>
												:null}
											</td>
											<td hidden={this.showColumn('FLAG_APHERESIS')} style={{textAlign:'center'}}>
												{p.type === "APHERESIS" ?
													<SvgIcon size={25} icon={notepad_add} 
														style={p.flag_apheresis > 0 ?
																{cursor:'pointer', color:'rgb(var(--primary))'}
															: 
																{cursor:'pointer', color:'#a39f9f'}
														}
														onClick={(e)=>this.props.history.push('/apheresis_details/'+p.id)}
														/>
												: null}
											</td>
											<td hidden={this.showColumn('RAI')} style={{textAlign:'center'}}>
												{p.last_rai}
											</td>
											<td hidden={this.showColumn('CONTROLS')} width="180">
												{p.from_hemo === 0 && <FloatingActionButton backgroundColor={'#ededed'}
													mini={true} style={{marginLeft:"5px"}} title="Etiquetas"
													iconStyle={{height: 33, width: 33}} disabled={p.flag_samples === 'NO_SAMPLES'}
													onClick={(e)=>this.viewSamples(e, p.id)}>
													<SvgIcon icon={ic_local_offer} className="icon-align"/>
												</FloatingActionButton>}

												<FloatingActionButton backgroundColor={'#ededed'}
													mini={true} style={{marginLeft:"5px"}} title="Información"
													iconStyle={{height: 33, width: 33}} 
													onClick={this.viewInformation.bind(this, p.id)}>
													<SvgIcon icon={search} className="icon-align"/>
												</FloatingActionButton>

												<FloatingActionButton backgroundColor={'#ededed'} mini={true} style={{marginLeft:"5px"}} 
													onClick={(e)=> this.printDocument(e, p.id, p.type)} title="Imprimir"
													iconStyle={{height: 33, width: 33}} >
													<SvgIcon icon={print} className="icon-align"/>
												</FloatingActionButton>

												{p.from_hemo === 0 && <FloatingActionButton backgroundColor={'#ededed'} mini={true} style={{marginLeft:"5px"}} 
													iconStyle={{height: 33, width: 33}} title="Editar"
													onClick={(e)=> this.editPetition(e, p.id)}
													disabled={!this.props.task_petitions.update || p.status === 'CANCELADA'}>
													<SvgIcon icon={pencil2} className="icon-align" disabled={!this.props.task_petitions.update} />
												</FloatingActionButton>}
												
												{p.from_hemo === 0 && <FloatingActionButton backgroundColor={'#ededed'} mini={true} style={{marginLeft:"5px"}} 
													iconStyle={{height: 33, width: 33}} title="Eliminar"
													onClick={(e)=> this.deletePetition(e, p.id)}
													disabled={!this.props.task_petitions.delete || p.status === 'CANCELADA'}>
													<SvgIcon icon={bin} className="icon-align" disabled={!this.props.task_petitions.detele} />
												</FloatingActionButton>}
											</td>
										</tr>
									: null
								})}
									
							</tbody>
						</Table>
					</div>
				</form>
				<ModalSamples {...this.props} 
					getList={this.criterials !== undefined ? this.criterials.onSearch : null} 
					onRef={ref => (this.modal_samples = ref)} 
					socket={this.props.socket}/>
				<ModalInfo {...this.props} onRef={ref => (this.modal_info = ref)} />
				<ModalSampleResult {...this.props} onRef={ref => (this.modal_sample_result = ref)} />
				<ModalLabels {...this.props} onRef={ref => (this.modal_label = ref)} directPrint={this.directPrint} />
				<ModalSample {...this.props} onRef={ref => (this.modal_sample = ref)} selectLabel={this.selectLabel} socket={this.props.socket} />
				<WaitingModal {...this.props} onRef={ref => (this.waiting_modal = ref)}/>
				<ModalCancel {...this.props} onRef={ref => (this.modal_cancel = ref)} getList={this.criterials !== undefined ? this.criterials.onSearch : null}/>
				<ModalFile {...this.props} getList={this.criterials !== undefined ? this.criterials.onSearch : null} onRef={ref => (this.modal_file = ref)}/>
				
			</div>
		)
	}
}

export default translate('translations') (PetitionRegister);